// Only catalogued slugs have local captures; other slugs must not produce broken thumbnail URLs.
const curatedThumbSlugs = new Set([
  "accelerated-wow",
  "agricogla",
  "battlecode",
  "bw",
  "cogherence",
  "cogherence-conversion-test",
  "cogriculture",
  "cogs-vs-clips",
  "cogtank",
  "crewrift",
  "crewrift-prime",
  "ctf",
  "ctf-doubles",
  "four-score",
  "generals-competition",
  "harvestbench",
  "heartleaf",
  "infinite-blocks",
  "jumper",
  "liars-cog",
  "moba",
  "muster",
  "nightshift",
  "nmmo",
  "nomic",
  "paintarena",
  "paintbot-royal",
  "persistent-wow",
  "planet-wars",
  "polis",
  "proxy-war",
  "proxywar-ffa-16p",
  "speedrun-wow",
  // Slugs follow the league names ("Sugarscape Solo" / "Sugarscape Duos");
  // the bare "sugarscape" segment is the landing page.
  "sugarscape-duos",
  "sugarscape-solo",
  "traverse-wow",
  "vanilla-wow",
  "vanilla-wow-episodic",
  "zero-sum",
]);

/** Where the browser fetches a league's shipped capture, or null when the
 * catalog has no file for that slug. */
export function curatedThumb(slug: string | null): string | null {
  return slug && curatedThumbSlugs.has(slug) ? `/thumbs/${slug}.webp` : null;
}
